import { relations, sql } from 'drizzle-orm'
import { boolean, index, pgTable, text, uniqueIndex } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getTimestampWithTimezone,
  typedJsonb,
} from '../common/utils'
import { emailAccounts } from './emailAccount'

export interface EmailRecipient {
  name: string
  email: string
}

export const emails = pgTable(
  'emails',
  {
    ...getBaseFields(),
    emailAccountId: getIdReference(() => emailAccounts.id),
    internetMessageId: text().notNull(),
    conversationId: text(),
    direction: text().notNull(), // 'inbound' | 'outbound'
    subject: text(),
    bodyPreview: text(),
    bodyHtml: text(),
    fromEmail: text().notNull(),
    fromName: text(),
    toRecipients: typedJsonb<EmailRecipient[]>('to_recipients'),
    ccRecipients: typedJsonb<EmailRecipient[]>('cc_recipients'),
    receivedAt: getTimestampWithTimezone().notNull(),
    hasAttachments: boolean().notNull().default(false),
    importance: text(),
    inReplyTo: text(),
    references: typedJsonb<string[]>('references'),
    isRead: boolean().notNull().default(false),
  },
  (table) => [
    ...getBaseIndexes('emails', table),
    uniqueIndex('emails_internet_message_id_idx')
      .on(table.internetMessageId)
      .where(sql`deleted_at IS NULL`),
    index('emails_email_account_id_idx').on(table.emailAccountId),
    index('emails_conversation_id_idx').on(table.conversationId),
    index('emails_from_email_idx').on(table.fromEmail),
    index('emails_received_at_idx').on(table.receivedAt),
  ],
)

export const emailsRelations = relations(emails, ({ one }) => ({
  emailAccount: one(emailAccounts, {
    fields: [emails.emailAccountId],
    references: [emailAccounts.id],
  }),
}))
